import React, { useState, useEffect } from "react";
import "./ONDCLandingPage.scss";
import config from "../../aws-exports";
import { API } from "aws-amplify";
import { useSelector } from "react-redux";
import { authData } from "../../redux/auth/authSlice";
import { awsSignIn } from "../../redux/auth/authSlice";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import MailIcon from "@mui/icons-material/Mail";
import PhoneIcon from "@mui/icons-material/Phone";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useDispatch } from "react-redux";
import course1 from "./assets/course1.png";
import { useHistory, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import AWS from "aws-sdk";
import jwt_decode from "jwt-decode";
import { StorageHelper } from "@aws-amplify/core";
import { useQueryParams } from "../../Hooks/useQueryParams";
import PageLoading from "../../components/PageLoading/PageLoading";
import { languageChange } from "../../api/api";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
function ONDCLandingPage(props) {
  const userDetails = useSelector(authData);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const query = useQueryParams();
  const dispatch = useDispatch();
  const [objJSON, setObjJSON] = useState({});
  const [loader, setLoader] = useState(true);
  const [selectedOptionLang, setSelectedOptionLang] = useState("1");
  const [language, setLanguage] = useState({});
  const storage = new StorageHelper().getStorage();
  let code = "";
  useEffect(() => {
    getJSON(selectedOptionLang);
    languageChangeLandingPRE(undefined, selectedOptionLang);
    showSlides(slideIndex);
    updatevisitCount();
    checkUserLogin();
  }, []);
  const updatevisitCount = async () => {
    let authT = localStorage.getItem("accessToken");
    const jsonString = JSON.stringify({
      oid: config.aws_org_id,
      schema: config.schema,
    });
    const base64EncodedString = btoa(jsonString);
    const bodyParam = {
      body: {
        json: base64EncodedString,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: authT,
      },
    };
    try {
      await API.post(
        config.aws_cloud_logic_custom_name,
        "/ONDCvisitCount",
        bodyParam
      );
    } catch (error) {
      return false;
    }
  };
  const languageChangeLandingPRE = async (userDetails, langCode) => {
    let authT = localStorage.getItem("accessToken");
    const jsonString = JSON.stringify({
      oid: config.aws_org_id,
      schema: config.schema,
      lang_code: langCode,
      ur_id: userDetails?.uData?.ur_id,
    });
    const base64EncodedString = btoa(jsonString);
    const bodyParam = {
      body: {
        json: base64EncodedString,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: authT,
      },
    };
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/languageChangePreLogin",
        bodyParam
      );
      setLanguage(response?.body?.languagejson);
    } catch (error) {
      return false;
    }
  };
  function loginClick() {
    window.location.href = `${config.auth_url}login?client_id=${config.aws_user_pools_web_client_id}&response_type=code&scope=email+openid+profile+aws.cognito.signin.user.admin&redirect_uri=${config.aws_cloudfront_lurl}`;
  }
  async function checkUserLogin() {
    setIsLoading(true);
    let accToken = Cookies.get("access_token");
    var idToken = Cookies.get("id_token");
    if (
      accToken === undefined ||
      idToken === undefined ||
      accToken === null ||
      idToken === null ||
      accToken === "" ||
      idToken === ""
    ) {
      if (
        (query.get("code") === undefined || query.get("code") === null) &&
        (new URLSearchParams(window.location.search).get("code") ===
          undefined ||
          new URLSearchParams(window.location.search).get("code") === null)
      ) {
        setIsLoading(false);
      } else {
        setIsLoading(true);
        code =
          query.get("code") === undefined || query.get("code") === null
            ? new URLSearchParams(window.location.search).get("code")
            : query.get("code");
        axios({
          method: "POST",
          url: config.auth_url + "oauth2/token",
          params: {
            grant_type: "authorization_code",
            client_id: config.aws_user_pools_web_client_id,
            redirect_uri: config.aws_cloudfront_lurl,
            code: code,
          },
          data: {},
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
          .then((resp) => {
            var decoded = jwt_decode(resp.data.id_token);
            fetchuser(resp, decoded);
          })
          .catch((error) => {});
      }
    } else {
      var decoded = jwt_decode(idToken);
      if (!AWS.config.region) {
        AWS.config.update({
          region: "ap-south-1",
        });
      }
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.aws_cognito_identity_pool_id,
        Logins: {
          [`cognito-idp.${"ap-south-1"}.amazonaws.com/${
            config.aws_user_pools_id
          }`]: idToken,
        },
      });
      var resp = {};
      resp.data = {};
      resp.data.id_token = idToken;
      resp.data.access_token = accToken;
      fetchuser(resp, decoded);
    }
  }
  async function fetchuser(resp, decoded) {
    AWS.config.region = "ap-south-1";
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: config.aws_cognito_identity_pool_id,
      Logins: {
        [`cognito-idp.${"ap-south-1"}.amazonaws.com/${
          config.aws_user_pools_id
        }`]: resp.data.id_token,
      },
    });
    Cookies.set("access_token", resp.data["access_token"]);
    Cookies.set("id_token", resp.data["id_token"]);
    const idTokenData = decodePayload(resp.data["id_token"]);
    const accessTokenData = decodePayload(resp.data["access_token"]);
    let userdata = {};
    userdata.id = AWS.config.credentials.identityId;
    storage.setItem(
      "CognitoIdentityServiceProvider." +
        config.aws_user_pools_web_client_id +
        ".LastAuthUser",
      idTokenData["cognito:username"]
    );
    storage.setItem(
      "CognitoIdentityServiceProvider." +
        config.aws_user_pools_web_client_id +
        "." +
        idTokenData["cognito:username"] +
        ".idToken",
      resp.data["id_token"]
    );
    storage.setItem(
      "CognitoIdentityServiceProvider." +
        config.aws_user_pools_web_client_id +
        "." +
        idTokenData["cognito:username"] +
        ".accessToken",
      resp.data["access_token"]
    );
    storage.setItem(
      "CognitoIdentityServiceProvider." +
        config.aws_user_pools_web_client_id +
        "." +
        idTokenData["cognito:username"] +
        ".refreshToken",
      resp.data["refresh_token"]
    );
    storage.setItem(
      "CognitoIdentityServiceProvider." +
        config.aws_user_pools_web_client_id +
        "." +
        idTokenData["cognito:username"] +
        ".clockDrift",
      "" + calculateClockDrift(accessTokenData["iat"], idTokenData["iat"]) + ""
    );
    storeData(decoded, userdata);
  }
  function removeDomain(email) {
    var atIndex = email.indexOf("@");
    if (atIndex !== -1) {
      var username = email.split("@")[0];
      return username;
    }
    return email;
  }
  const [state, setState] = React.useState({
    right: false,
  });
  const handleSelectChange = (event) => {
    setSelectedOptionLang(event.target.value);
    localStorage.setItem("lang", event.target.value);
    getJSON(event.target.value);
    languageChangeLandingPRE(undefined, event.target.value);
  };
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <ListItem disablePadding>
          <nav className="mobileNavONDC">
            <ul>
              <div style={{ textAlign: "end" }}>
                <CloseOutlinedIcon
                  style={{ fontSize: "2.8rem", color: "#2097d7" }}
                  onClick={toggleDrawer(anchor, false)}
                />
              </div>
              <li>
                <a href="#" onClick={(e) => smoothScroll("#Home")}>
                  {`${language?.Landing_Page?.Home || "Home"}`}
                </a>
              </li>
              <li>
                <a href="#" onClick={(e) => smoothScroll("#About")}>
                  {`${language?.Landing_Page?.About || "About"}`}
                </a>
              </li>
              <li>
                <a href="#" onClick={(e) => smoothScroll("#Courses")}>
                  {`${language?.Landing_Page?.Courses || "Courses"}`}
                </a>
              </li>
              <li>
                <a href="#" onClick={(e) => smoothScroll("#FAQ")}>
                  {`${language?.Landing_Page?.FAQs || "FAQ's"}`}
                </a>
              </li>
              {/* <Divider /> */}
              <li>
                <button
                  style={{ marginRight: "1rem" }}
                  className="toggle-btn"
                  title="Toggle Dark Mode"
                  onClick={() => {
                    toggleDarkMode();
                  }}
                >
                  &#127769;
                </button>
              </li>
              <li>
                <button style={{ margin: "1rem" }} className="buttonONDC">
                  <select
                    name="pets"
                    id="pet-select"
                    style={{
                      border: "none",
                      background: "transparent",
                      fontSize: "1.5rem",
                      color: "#8e8e8e",
                    }}
                    value={selectedOptionLang}
                    onChange={handleSelectChange}
                  >
                    <option value="1">English</option>
                    <option value="3">Hindi</option>
                    <option value="2">Kannada</option>
                    <option value="6">Marathi</option>
                    <option value="4">Tamil</option>
                    <option value="5">Gujarati</option>
                    <option value="7">Telugu</option>
                    <option value="8">Bengali</option>
                    <option value="9">Assamese</option>
                    <option value="10">Oriya</option>
                    <option value="11">Malayalam</option>
                  <option value="12">Punjabi</option>
                  </select>
                </button>
              </li>
              <li>
                <button
                  className="buttonONDC"
                  style={{ margin: "1rem" }}
                  onClick={() => {
                    loginClick();
                  }}
                >
                  {`${language?.Landing_Page?.Sign_in || "Sign in"}`}
                </button>
              </li>
            </ul>
          </nav>
        </ListItem>
      </List>
    </Box>
  );
  const getJSON = async (code) => {
    setLoader(true);
    let authT = localStorage.getItem("accessToken");
    let body = {
      lang_code: code,
      schema: config.schema,
    };
    try {
      const requestBody = body;
      const jsonString = JSON.stringify(requestBody);
      const base64EncodedString = btoa(jsonString);
      const reportInfo = `/getLandingPageJSON?json=${encodeURIComponent(
        base64EncodedString
      )}`;
      const response = await API.get(
        config.aws_cloud_logic_custom_name,
        reportInfo,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: authT,
          },
        }
      );
      setObjJSON(response);
      setLoader(false);
    } catch (err) {}
  };
  const addUserBeforeLogin = async (userdata) => {
    let authkey = localStorage.getItem("accessToken");
    let body = {
      type: "signup",
      eid: userdata.username,
      emailid: userdata.emailid,
      gen: 0,
      first_name: removeDomain(userdata.emailid),
      last_name: "",
      dev: 2,
      st_id: 2,
      cno: null,
      schema: config.schema,
    };
    body.tenant = userdata.locale;
    if (!userdata.locale) {
      body.tenant = "NSECORPORATE";
    }
    const jsonString = JSON.stringify(body);
    const base64EncodedString = btoa(jsonString);
    const bodyParam = {
      body: {
        json: base64EncodedString,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: authkey,
      },
    };
    try {
      await API.post(
        config.aws_cloud_logic_custom_name,
        "/addUserBeforeLogin",
        bodyParam
      );
      userdata.newUser = true;
      getUserDetailsBeforeLogin(userdata);
    } catch (err) {}
  };
  async function storeData(decoded, userdata) {
    userdata.cid = config.aws_user_pools_web_client_id;
    userdata.emailid = decoded.email;
    userdata.iid = config.aws_cognito_identity_pool_id;
    userdata.uid = config.aws_user_pools_id;
    userdata.email = decoded.email;
    userdata.username = decoded.sub;
    userdata.locale = decoded.locale;
    if (!decoded.locale) {
      userdata.locale = "NSECORPORATE";
    }
    userdata.family_name = decoded.family_name;
    userdata.given_name = decoded.given_name;
    userdata.cgroups = decoded["cognito:groups"];
    userdata.groups = decoded["custom:groups"];
    userdata.schema = config.schema;
    //tok
    await getUserDetailsBeforeLogin(userdata);
  }
  const decodePayload = (jwtToken) => {
    const payload = jwtToken.split(".")[1];
    try {
      return JSON.parse(Buffer.from(payload, "base64").toString("utf8"));
    } catch (err) {
      return {};
    }
  };
  const getUserDetailsBeforeLogin = async (userdata) => {
    let authkey = localStorage.getItem("accessToken");
    const requestBody = {
      emailid: userdata.email,
      schema: config.schema,
    };
    try {
      //const requestBody = userdata;
      const jsonString = JSON.stringify(requestBody);
      const base64EncodedString = btoa(jsonString);
      const reportInfo = `/getUserDetailsBeforeLogin?json=${encodeURIComponent(
        base64EncodedString
      )}`;
      const response = await API.get(
        config.aws_cloud_logic_custom_name,
        reportInfo,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: authkey,
          },
        }
      );
      if (response) {
        userdata.uData = response.body[0];
        if (response.body[0] !== undefined) {
          getUserToken(userdata);
        } else {
          addUserBeforeLogin(userdata);
        }
      }
    } catch (err) {}
  };
  async function getUserToken(userdata) {
    const tokenrequestBody = {
      client_key: userdata.email,
      client_secret: config.secretKeyAfter,
      schema: config.schema,
    };
    let authkey = localStorage.getItem("accessToken");
    const tokenjsonString = JSON.stringify(tokenrequestBody);
    const tokenbase64EncodedString = btoa(tokenjsonString);
    const tokenreportInfo = `/getUserToken?json=${encodeURIComponent(
      tokenbase64EncodedString
    )}`;
    const tokenresponse = await API.get(
      config.aws_cloud_logic_custom_name,
      tokenreportInfo,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: authkey,
        },
      }
    );
    userdata.accessToken = tokenresponse.accessToken;
    userdata.refreshToken = tokenresponse.refreshToken;
    userdata.beforeAuth = authkey;
    localStorage.setItem("after_logIn_accessToken", tokenresponse?.accessToken);
    window.after_logIn_accessToken = tokenresponse?.accessToken
    if (tokenresponse) {
      analyticsWebApp(userdata);
    }
  }
  async function analyticsWebApp(userDetails) {
    const bodydata = {
      oid: config.aws_org_id,
      eventtype: "AuthenticatedViaCognito",
      id: userDetails.id,
      iid: config.aws_cognito_identity_pool_id,
      email: userDetails.username,
      name: userDetails.name,
      emailid: userDetails.email,
      tenant: userDetails.locale,
      ur_id: userDetails.uData?.ur_id,
      schema: config.schema,
    };
    bodydata.emailid = userDetails.emailid;
    const jsonString = JSON.stringify(bodydata);
    const base64EncodedString = btoa(jsonString);
    const bodyParam = {
      body: {
        json: base64EncodedString,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: userDetails?.accessToken,
      },
    };
    try {
      await API.post(
        config.aws_cloud_logic_custom_name,
        "/analyticsWebApp",
        bodyParam
      );
      if (userDetails?.newUser == undefined) {
        let lang = await languageChange(userDetails, userDetails.uData?.lang);
        userDetails.languagejson = lang?.languagejson;
        userDetails.themeDark = "light";
      }
      if (userDetails?.newUser == true) {
        let gotLang = localStorage.getItem("lang");
        let languageAdd = "1";
        if (gotLang !== null) {
          languageAdd = gotLang;
        }
        let lang = await languageChange(userDetails, languageAdd);
        userDetails.languagejson = lang?.languagejson;
        userDetails.themeDark = "light";
      }
      setIsLoading(false);
      dispatch(awsSignIn(userDetails));
      let id = query.get("id");
      if (location.pathname === "/course" && id) {
        history.push(`/course?id=${id}`);
      } else if (location.pathname === "/content" && id) {
        history.push(`/content?id=${id}`);
      } else {
        history.push("/home");
      }
    } catch (err) {
      history.push("/home");
    }
  }
  const calculateClockDrift = (iatAccessToken, iatIdToken) => {
    const now = Math.floor(new Date() / 1000);
    const iat = Math.min(iatAccessToken, iatIdToken);
    return now - iat;
  };
  document.addEventListener("DOMContentLoaded", function() {
    var toggleBtn = document.querySelector(".toggle-btn");
    toggleBtn.addEventListener("click", toggleDarkMode);
    function toggleDarkMode() {
      document.body.classList.toggle("dark-mode");
      document.querySelector("header").classList.toggle("dark-mode");
      var sections = document.querySelectorAll("section");
      for (var k = 0; k < sections.length; k++) {
        sections[k].classList.toggle("dark-mode");
      }
    }
  });
  function toggleDarkMode() {
    document.body.classList.toggle("dark-mode");
    document.querySelector("header").classList.toggle("dark-mode");
    var sections = document.querySelectorAll("section");
    for (var k = 0; k < sections.length; k++) {
      sections[k].classList.toggle("dark-mode");
    }
  }
  document.addEventListener("DOMContentLoaded", function() {
    var links = document.querySelectorAll("header nav ul li a");
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener("click", smoothScroll);
    }
    function smoothScroll(e) {
      e.preventDefault();
      var targetId = this.getAttribute("href");
      var targetPosition = document.querySelector(targetId).offsetTop;
      var startPosition = window.pageYOffset;
      var distance = targetPosition - startPosition;
      var duration = 1000; // Animation duration in milliseconds
      var startTime = null;
      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        var timeElapsed = currentTime - startTime;
        var run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      }
      function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }
      requestAnimationFrame(animation);
    }
  });
  function smoothScroll(e) {
    var targetId = e;
    var targetPosition = document.querySelector(targetId).offsetTop;
    var startPosition = window.pageYOffset;
    var distance = targetPosition - startPosition;
    var duration = 1000; // Animation duration in milliseconds
    var startTime = null;
    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      var timeElapsed = currentTime - startTime;
      var run = ease(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    }
    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    }
    requestAnimationFrame(animation);
  }
  document.addEventListener("DOMContentLoaded", function() {
    let slideIndex = 1;
    showSlides(slideIndex);
    document.getElementById("prev").addEventListener("click", plusSlides(-1));
    document.getElementById("next").addEventListener("click", plusSlides(1));
    document
      .getElementById("slide1")
      .addEventListener("click", currentSlide(1));
    document
      .getElementById("slide2")
      .addEventListener("click", currentSlide(2));
    document
      .getElementById("slide3")
      .addEventListener("click", currentSlide(3));
    function plusSlides(n) {
      showSlides((slideIndex += n));
    }
    function currentSlide(n) {
      showSlides((slideIndex = n));
    }
    function showSlides(n) {
      let j;
      let slides = document.getElementsByClassName("mySlides");
      let dots = document.getElementsByClassName("dot");
      if (n > slides.length) {
        slideIndex = 1;
      }
      if (n < 1) {
        slideIndex = slides.length;
      }
      for (j = 0; j < slides.length; j++) {
        slides[j].style.display = "none";
      }
      for (j = 0; j < dots.length; j++) {
        dots[j].className = dots[j].className.replace(" active", "");
      }
      slides[slideIndex - 1].style.display = "block";
      dots[slideIndex - 1].className += " active";
    }
  });
  let slideIndex = 1;
  function plusSlides(n) {
    showSlides((slideIndex += n));
  }
  function currentSlide(n) {
    showSlides((slideIndex = n));
  }
  function showSlides(n) {
    let j;
    let slides = document.getElementsByClassName("mySlides");
    let dots = document.getElementsByClassName("dot");
    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }
    for (j = 0; j < slides.length; j++) {
      slides[j].style.display = "none";
    }
    for (j = 0; j < dots.length; j++) {
      dots[j].className = dots[j].className.replace(" active", "");
    }
    slides[slideIndex - 1].style.display = "block";
    dots[slideIndex - 1].className += " active";
  }
  return (
    <>
      {!isLoading ? (
        <body
          style={{
            background: "linear-gradient(90deg, #EBF4FD, #F5FBF5)",
            fontFamily: "Heebo",
            margin: "0",
            padding: 0,
          }}
        >
          <header className="headerONDC">
            <img
              src={`${
                config.aws_cloudfront_url
              }${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/${
                config.aws_org_id
              }.png`}
              alt="ONDC Logo"
              className="header-logo imgONDC"
            />
            <div className="mobileMenuItems">
              {["right"].map((anchor) => (
                <React.Fragment key={anchor}>
                  <Button
                    onClick={toggleDrawer(anchor, true)}
                    style={{ padding: "0", minWidth: "0" }}
                  >
                    <MenuOutlinedIcon
                      style={{ fontSize: "2.8rem", color: "#2097d7" }}
                    />
                  </Button>
                  <Drawer
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}
                  >
                    {list(anchor)}
                  </Drawer>
                </React.Fragment>
              ))}
            </div>
            <div className="header-menu">
              <nav className="navONDC">
                <ul>
                  <li>
                    <a href="#" onClick={(e) => smoothScroll("#Home")}>
                      {`${language?.Landing_Page?.Home || "Home"}`}
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={(e) => smoothScroll("#About")}>
                      {`${language?.Landing_Page?.About || "About"}`}
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={(e) => smoothScroll("#Courses")}>
                      {`${language?.Landing_Page?.Courses || "Courses"}`}
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={(e) => smoothScroll("#FAQ")}>
                      {`${language?.Landing_Page?.FAQs || "FAQ's"}`}
                    </a>
                  </li>
                  <li>
                    <button
                      style={{ marginRight: "1rem" }}
                      className="toggle-btn"
                      title="Toggle Dark Mode"
                      onClick={() => {
                        toggleDarkMode();
                      }}
                    >
                      &#127769;
                    </button>
                  </li>
                  <li>
                    <button
                      style={{ padding: "0.67rem" }}
                      className="buttonONDC"
                    >
                      <select
                        name="pets"
                        id="pet-select"
                        style={{
                          border: "none",
                          background: "transparent",
                          fontSize: "1.5rem",
                          color: "#8e8e8e",
                        }}
                        value={selectedOptionLang}
                        onChange={handleSelectChange}
                      >
                        <option value="1">English</option>
                        <option value="3">Hindi</option>
                        <option value="2">Kannada</option>
                        <option value="6">Marathi</option>
                        <option value="4">Tamil</option>
                        <option value="5">Gujarati</option>
                        <option value="7">Telugu</option>
                        <option value="8">Bengali</option>
                        <option value="9">Assamese</option>
                    <option value="10">Oriya</option>
                    <option value="11">Malayalam</option>
                  <option value="12">Punjabi</option>
                      </select>
                    </button>
                  </li>
                  <li>
                    <button
                      className="buttonONDC"
                      onClick={() => {
                        loginClick();
                      }}
                    >
                      {`${language?.Landing_Page?.Sign_in || "Sign in"}`}
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </header>
          <div>
            <section
              id="Home"
              style={{ padding: "2rem 2rem 4rem", overflowY: "auto" }}
              className="sectionContainer"
            >
              <div className="slideshow-container">
                <div className="mySlides fade" style={{ display: "block" }}>
                  {!loader && (
                    <div
                      className="imageTextContainer"
                      dangerouslySetInnerHTML={objJSON?.Home[0]}
                    ></div>
                  )}
                </div>
                <div className="mySlides fade">
                  {!loader && (
                    <div
                      className="imageTextContainer"
                      dangerouslySetInnerHTML={objJSON?.Home[1]}
                    ></div>
                  )}
                </div>
                <div className="mySlides fade">
                  {!loader && (
                    <div
                      className="imageTextContainer"
                      dangerouslySetInnerHTML={objJSON?.Home[2]}
                    ></div>
                  )}
                </div>
                <div>
                  <a className="prev" onClick={() => plusSlides(-1)}>
                    ❮
                  </a>
                  <a className="next" onClick={() => plusSlides(1)}>
                    ❯
                  </a>
                </div>
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "6rem",
                  position: "absolute",
                  right: "3rem",
                  display: "flex",
                }}
              >
                <span className="dot" onClick={() => currentSlide(1)}></span>
                <span className="dot" onClick={() => currentSlide(2)}></span>
                <span className="dot" onClick={() => currentSlide(3)}></span>
              </div>
            </section>
            {!loader && <div dangerouslySetInnerHTML={objJSON?.About}></div>}
            <section id="Courses" className="sectionContainer">
              <h2 className="mainSecondHeader">
                {" "}
                {`${language?.Landing_Page?.ONDC_Courses ||
                  "ONDC Courses"}`}{" "}
              </h2>
              <div>
                <div
                  style={{
                    display: "flex",
                    gap: "1.5rem",
                    margin: "3rem 0rem 0rem",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  <card className="cardONDC">
                    <img
                      src={course1}
                      alt="Course Image 1"
                      className="imgONDC"
                      style={{
                        width: "100%",
                        borderTopLeftRadius: "1.5rem",
                        borderTopRightRadius: "1.5rem",
                      }}
                    />
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={`${
                            config.aws_cloudfront_url
                          }${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/${
                            config.aws_org_id
                          }.png`}
                          alt="ONDC Logo"
                          className="imgONDC"
                          style={{ width: "4rem" }}
                        />
                        <p className="paragraphONDC">
                          {`${language?.Landing_Page?.Open_Network ||
                            "Open Network for Digital Commerce"}`}
                        </p>
                      </div>
                      <h3
                        style={{ margin: "5px 0px 10px", cursor: "pointer" }}
                        className="h3ONDC"
                        onClick={() => {
                          loginClick();
                        }}
                      >
                        {`${language?.Landing_Page?.Seller_Network ||
                          "Seller Network Participant (NP) Excellence"}`}
                      </h3>
                      <p
                        style={{ margin: "5px 0px 10px" }}
                        className="paragraphONDC"
                      >
                        {`${language?.Landing_Page?.Course_Description ||
                          "Seller Network Participant is responsible for connecting sellers to the ONDC network through a seller application. They are also responsible for digitizing the seller's catalogue and dispersing payments."}`}
                      </p>
                    </div>
                  </card>
                  <card className="cardONDC">
                    <img
                      src={`${
                        config.aws_cloudfront_url
                      }${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/${
                        config.aws_org_id
                      }.png`}
                      alt="Course Image 1"
                      className="imgONDC"
                      style={{
                        width: "100%",
                        borderTopLeftRadius: "1.5rem",
                        borderTopRightRadius: "1.5rem",
                        margin: "6.8rem 0rem",
                      }}
                    />
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={`${
                            config.aws_cloudfront_url
                          }${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/${
                            config.aws_org_id
                          }.png`}
                          alt="ONDC Logo"
                          className="imgONDC"
                          style={{ width: "4rem" }}
                        />
                        <p className="paragraphONDC">
                          {`${language?.Landing_Page?.Open_Network ||
                            "Open Network for Digital Commerce"}`}
                        </p>
                      </div>
                      <h3 style={{ margin: "5px 0px 10px" }} className="h3ONDC">
                        {`${language?.Landing_Page?.More_Courses ||
                          "Watch this space for more Updates."}`}
                      </h3>
                    </div>
                  </card>
                  <card className="cardONDC">
                    <img
                      src={`${
                        config.aws_cloudfront_url
                      }${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/${
                        config.aws_org_id
                      }.png`}
                      alt="Course Image 1"
                      className="imgONDC"
                      style={{
                        width: "100%",
                        borderTopLeftRadius: "1.5rem",
                        borderTopRightRadius: "1.5rem",
                        margin: "6.8rem 0rem",
                      }}
                    />
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={`${
                            config.aws_cloudfront_url
                          }${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/${
                            config.aws_org_id
                          }.png`}
                          alt="ONDC Logo"
                          className="imgONDC"
                          style={{ width: "4rem" }}
                        />
                        <p className="paragraphONDC">
                          {`${language?.Landing_Page?.Open_Network ||
                            "Open Network for Digital Commerce"}`}
                        </p>
                      </div>
                      <h3 style={{ margin: "5px 0px 10px" }} className="h3ONDC">
                        {`${language?.Landing_Page?.More_Courses ||
                          "Watch this space for more Updates."}`}
                      </h3>
                    </div>
                  </card>
                  <card className="cardONDC">
                    <img
                      src={`${
                        config.aws_cloudfront_url
                      }${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/${
                        config.aws_org_id
                      }.png`}
                      alt="Course Image 1"
                      className="imgONDC"
                      style={{
                        width: "100%",
                        borderTopLeftRadius: "1.5rem",
                        borderTopRightRadius: "1.5rem",
                        margin: "6.8rem 0rem",
                      }}
                    />
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={`${
                            config.aws_cloudfront_url
                          }${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/${
                            config.aws_org_id
                          }.png`}
                          alt="ONDC Logo"
                          className="imgONDC"
                          style={{ width: "4rem" }}
                        />
                        <p className="paragraphONDC">
                          {`${language?.Landing_Page?.Open_Network ||
                            "Open Network for Digital Commerce"}`}
                        </p>
                      </div>
                      <h3 style={{ margin: "5px 0px 10px" }} className="h3ONDC">
                        {`${language?.Landing_Page?.More_Courses ||
                          "Watch this space for more Updates."}`}
                      </h3>
                    </div>
                  </card>
                </div>
              </div>
            </section>
            {!loader && <div dangerouslySetInnerHTML={objJSON?.FAQ}></div>}
          </div>
          <footer className="footerONDC">
            <div className="footerONDCContainer">
              <div className="contactUsONDC" style={{ marginBottom: "1rem" }}>
                <div>
                  <p className="footerLinks">
                    {`${language?.Landing_Page?.Contact_Us ||
                      "Contact Us: For Technical Support"}`}
                  </p>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                      }}
                    >
                      <PhoneIcon
                        style={{ fontSize: "2rem", color: "#454545" }}
                      />
                      <p className="paragraphONDC">022-68646464</p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                        margin: "8px 0px",
                      }}
                    >
                      <MailIcon
                        style={{ fontSize: "2rem", color: "#454545" }}
                      />
                      <a
                        href="mailto:support.ondc@nse.co.in"
                        title="mailto:support.ondc@nse.co.in"
                        target="_blank"
                        style={{ textDecoration: "none" }}
                      >
                        <b>
                          <span>support.ondc@nse.co.in</span>
                        </b>
                      </a>
                    </div>
                    <p className="paragraphONDC">
                      {`${language?.Landing_Page?.Contact_Us ||
                        "Contact Us: For Technical Support"}`}
                      - 09:30am to 05.45pm
                    </p>
                  </div>
                </div>
              </div>
              <a
                href="https://www.ondc.org/privacy-policy/"
                className="footerLinks"
                target="_blank"
              >
                {`${language?.Landing_Page?.Privacy_Policy ||
                  "Privacy Policy"}`}
              </a>
              <a
                href={`
                  ${
                    config.aws_cloudfront_url
                  }${config.aws_org_id.toLowerCase()}-resources/documents/Terms_${selectedOptionLang}.pdf`}
                className="footerLinks"
                target="_blank"
              >
                {`${language?.Landing_Page?.Terms_and_Conditions ||
                  "Terms and Conditions"}`}
              </a>
              <a
                href={`
                ${
                  config.aws_cloudfront_url
                }${config.aws_org_id.toLowerCase()}-resources/documents/DataPolicy_${selectedOptionLang}.pdf`}
                class="footerLinks"
                target="_blank"
              >
                {`${language?.Landing_Page?.Data_Policy || "Data Policy"}`}
              </a>
            </div>
            <div className="InnerFooterONDC">
              <img
                src={`${
                  config.aws_cloudfront_url
                }${config.aws_org_id.toLocaleLowerCase()}-resources/images/org-images/${
                  config.aws_org_id
                }.png`}
                alt="ONDC Logo"
                className="imgONDC"
                style={{ width: "9rem", height: "4rem" }}
              />
              <div>
                <a href="" className="footerLinks">
                  ONDC | Open Network for Digital Commerce © 2023
                </a>
                <div className="footerIcons">
                  <a
                    href="https://www.facebook.com/people/ONDC-Ltd/100076520217598/"
                    className="fa fa-facebook"
                    target="_blank"
                  >
                    <FacebookOutlinedIcon style={{ fontSize: "2.4rem" }} />
                  </a>
                  <a
                    href="https://twitter.com/ONDC_Official"
                    className="fa fa-twitter"
                    target="_blank"
                  >
                    <TwitterIcon style={{ fontSize: "2.4rem" }} />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/open-network-for-digital-commerce/"
                    className="fa fa-linkedin"
                    target="_blank"
                  >
                    <LinkedInIcon style={{ fontSize: "2.4rem" }} />
                  </a>
                  <a
                    href="https://www.youtube.com/@ondc1300"
                    className="fa fa-youtube"
                    target="_blank"
                  >
                    <YouTubeIcon style={{ fontSize: "2.6rem" }} />
                  </a>
                  <a
                    href="https://www.kooapp.com/profile/OpenNetworkForDigitalCommerce"
                    target="_blank"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 210 302"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      id="IconChangeColor"
                    >
                      {" "}
                      <path
                        fill="#454545"
                        d="M63.4181 65.4727L67.9181 60.4727L78.9181 47.4727L95.9181 37.9727L98.9181 32.9727L101.918 24.4727V17.4727L106.918 11.9727L109.918 4.97266H115.918L126.918 10.4727L133.918 22.4727L134.918 36.4727L151.418 45.4727L160.918 52.4727L169.418 63.4727L179.418 86.9727L183.418 101.973L185.918 119.973L188.418 136.973L196.918 144.473L201.418 157.473L205.918 169.973L207.418 183.473L201.418 195.473L192.918 203.473L181.918 205.473L179.918 214.473L174.918 226.973L164.418 239.473L152.918 249.473L137.418 255.473L119.918 259.973H91.4181L70.4181 257.473L46.4181 249.473L32.4181 242.473L22.4181 235.473L15.4181 229.973L8.41809 221.473L3.41809 214.473L5.41809 203.973L13.9181 198.973V191.473L17.4181 179.473L24.4181 165.473L30.9181 153.973L37.4181 144.473L43.9181 138.473L48.9181 134.973V126.473L50.4181 116.473L51.9181 100.473L54.9181 86.9727L58.9181 74.4727L63.4181 65.4727Z"
                        stroke="#ffffff"
                        id="mainIconPathAttribute"
                        stroke-width="2"
                      ></path>{" "}
                      <path
                        d="M209.338 173.615V173.315C208.307 163.247 205.151 153.513 200.078 144.755C198.663 142.338 197.044 140.047 195.238 137.905C194.587 137.141 193.786 136.519 192.885 136.077C191.983 135.635 191.001 135.383 189.998 135.335C189.948 134.725 189.888 134.115 189.828 133.505C189.468 129.715 189.068 126.005 188.658 122.405C188.548 121.505 188.448 120.605 188.338 119.725L188.098 117.805C188.098 117.605 188.098 117.395 188.018 117.195C187.968 116.765 187.908 116.335 187.848 115.905C187.848 115.665 187.788 115.425 187.748 115.185C187.698 114.795 187.638 114.415 187.588 114.025C187.538 113.635 187.518 113.535 187.478 113.285C187.438 113.035 187.368 112.535 187.308 112.155C187.248 111.775 187.238 111.675 187.198 111.435C187.138 111.045 187.078 110.655 187.008 110.265C187.008 110.055 186.948 109.835 186.908 109.625C186.828 109.155 186.758 108.695 186.678 108.245C186.678 108.105 186.628 107.975 186.608 107.845C186.508 107.255 186.408 106.675 186.298 106.095L186.208 105.615C186.128 105.195 186.058 104.775 185.978 104.365L185.858 103.735C185.788 103.375 185.718 103.015 185.638 102.665C185.558 102.315 185.548 102.215 185.508 101.985L185.298 100.985C185.248 100.765 185.198 100.545 185.158 100.325C185.118 100.105 185.008 99.6354 184.928 99.3254C184.848 99.0154 184.838 98.9154 184.798 98.7054C184.708 98.3254 184.628 97.9554 184.538 97.5754C184.538 97.4154 184.468 97.2554 184.428 97.0854C184.308 96.5554 184.178 96.0254 184.048 95.5054L183.988 95.2554C183.878 94.8154 183.778 94.3754 183.668 93.9454L183.518 93.3954C183.438 93.0654 183.348 92.7354 183.268 92.3954L183.108 91.7854C183.018 91.4754 182.938 91.1754 182.858 90.8654C182.778 90.5554 182.748 90.4654 182.688 90.2554C182.628 90.0454 182.518 89.6554 182.438 89.3554C182.358 89.0554 182.318 88.9654 182.268 88.7654L181.988 87.8254L181.838 87.3054C181.718 86.9054 181.588 86.5054 181.468 86.1154C181.468 86.0354 181.468 85.9554 181.398 85.8754C181.248 85.4054 181.108 84.9454 180.958 84.4854L180.808 84.0254C180.698 83.7154 180.598 83.4054 180.498 83.0954L180.318 82.5554C180.218 82.2854 180.128 82.0054 180.028 81.7254C179.928 81.4454 179.898 81.3654 179.838 81.1754C179.778 80.9854 179.648 80.6454 179.548 80.3754L179.358 79.8354L179.058 79.0254C178.998 78.8654 178.928 78.6954 178.868 78.5254C178.808 78.3554 178.638 77.9254 178.518 77.6154C178.518 77.4954 178.428 77.3654 178.378 77.2454C178.218 76.8254 178.048 76.4154 177.888 76.0054L177.738 75.6454L177.378 74.7654L177.178 74.2954L176.858 73.5454C176.788 73.3754 176.708 73.2154 176.638 73.0454L176.328 72.3454C176.258 72.1754 176.178 72.0154 176.108 71.8454L175.788 71.1554C175.718 70.9954 175.648 70.8354 175.568 70.6754C175.488 70.5154 175.338 70.1954 175.228 69.9454C175.118 69.6954 175.098 69.6754 175.028 69.5354L174.518 68.5354C174.486 68.4535 174.449 68.3734 174.408 68.2954L173.938 67.3654L173.728 66.9654L173.378 66.2954L173.138 65.8454L172.798 65.2254L172.558 64.7854C172.448 64.5854 172.338 64.3854 172.218 64.1854L171.978 63.7454C171.858 63.5454 171.738 63.3454 171.628 63.1454L171.388 62.7354L170.978 61.9854C170.978 61.8854 170.868 61.7954 170.818 61.7054C170.618 61.3854 170.428 61.0654 170.228 60.7054L170.018 60.3754L169.628 59.7554L169.378 59.3754L169.018 58.8254L168.758 58.4354L168.408 57.9154L168.138 57.5254L167.778 57.0154L167.518 56.6454C167.388 56.4554 167.248 56.2754 167.118 56.0954C166.988 55.9154 166.968 55.8854 166.888 55.7754L166.278 54.9554L166.098 54.7154L165.648 54.1354L165.378 53.7954L165.008 53.3254L164.718 52.9754L164.358 52.5354L164.068 52.1854L163.708 51.7554L163.418 51.4254L162.978 50.9854L162.718 50.6854L162.228 50.1454L162.018 49.9154L161.418 49.2654L161.148 48.9954L160.748 48.5754L160.458 48.2854L160.078 47.8954L159.778 47.5954L159.398 47.2354L159.098 46.9454L158.718 46.5754L158.428 46.3054L157.988 45.9054L157.748 45.6854L157.078 45.0954L156.838 44.8954L156.108 44.2654L155.708 43.9354L155.398 43.6854L155.018 43.3754L154.708 43.1354L154.318 42.8354L154.008 42.5954L153.588 42.2854L153.308 42.0754L152.708 41.6454L152.458 41.4554L151.938 41.0954L151.648 40.8954L151.238 40.6254L150.928 40.4154L150.528 40.1554L150.218 39.9554L149.818 39.7054L149.508 39.5154L149.098 39.2654L148.798 39.0854L148.318 38.7954L148.098 38.6654L147.408 38.2754L147.138 38.1354L146.698 37.8954L146.398 37.7354L145.988 37.5154L145.668 37.3554L145.278 37.1554L144.978 36.9854L144.568 36.7854L143.818 36.4354L143.558 36.3154L142.868 36.0054L142.648 35.9054L142.158 35.6954L141.868 35.5754L141.448 35.3954L141.138 35.2754L140.738 35.1154L140.428 34.9954L140.018 34.8354L139.718 34.7254L139.288 34.5654L139.008 34.4654L138.258 34.2154L137.608 33.9954L137.438 33.9454C138.183 29.9178 138.074 25.7788 137.117 21.7962C136.161 17.8136 134.38 14.076 131.888 10.8254C127.368 4.82536 120.968 0.975364 115.578 0.975364C114.264 0.943395 112.959 1.1948 111.751 1.71248C110.543 2.23016 109.461 3.00196 108.578 3.97536C106.976 5.72404 106.047 7.9853 105.958 10.3554C104.195 10.5923 102.541 11.3467 101.206 12.5232C99.8711 13.6998 98.9149 15.2456 98.4582 16.9654C98.0967 18.2854 98.0284 19.6685 98.2582 21.0177C98.488 22.3669 99.0102 23.6494 99.7882 24.7754C97.6282 26.7754 95.6882 29.8854 95.4782 34.9354C92.3269 36.032 89.2645 37.3693 86.3182 38.9354C85.6382 39.2954 84.9682 39.6754 84.3182 40.0654C83.6682 40.4554 83.1882 40.7354 82.6282 41.0654C82.2182 41.3154 81.8082 41.5854 81.3982 41.8554C80.1715 42.6554 78.9515 43.522 77.7382 44.4554C77.3382 44.7654 76.9282 45.0754 76.5282 45.4554C75.7782 46.0554 75.0382 46.6854 74.2982 47.3454C73.5582 48.0054 72.6182 48.8654 71.7882 49.6754C70.6282 50.8254 69.4782 52.0354 68.3582 53.3254C67.8182 53.9454 67.2882 54.5854 66.7582 55.2354C66.2282 55.8854 65.9382 56.2354 65.5382 56.7854L64.8782 57.6554C64.2282 58.5354 63.5882 59.4354 62.9582 60.3654C62.3282 61.2954 61.5982 62.4554 60.9582 63.5454C60.4782 64.3454 60.0182 65.1554 59.5482 65.9854C59.2082 66.6054 58.8682 67.2354 58.5482 67.8754C57.9282 69.0754 57.3182 70.3054 56.7282 71.5854C55.6082 73.9987 54.5615 76.5587 53.5882 79.2654C52.9882 80.912 52.4215 82.622 51.8882 84.3954C51.5282 85.5754 51.1782 86.7954 50.8382 88.0354C50.4982 89.2754 50.2182 90.4254 49.9282 91.6554C49.8382 92.0354 49.7482 92.4154 49.6682 92.8054C49.3682 94.1154 49.0882 95.4654 48.8182 96.8054C48.5882 97.9854 48.3682 99.1854 48.1682 100.405C47.7549 102.845 47.3949 105.372 47.0882 107.985C46.7415 110.992 46.4615 114.115 46.2482 117.355C46.1282 119.175 46.0282 120.955 45.9382 122.695C45.8482 124.435 45.7682 126.155 45.6982 127.835C45.6282 129.515 45.5782 131.165 45.5282 132.775V133.875C43.9682 133.875 39.2282 133.875 26.5282 154.635C19.1982 166.635 13.0582 179.485 10.5282 188.165C9.52821 191.455 8.60821 195.675 9.59821 198.745H9.49821L8.99821 198.845L8.77821 198.895L8.31821 198.995L8.10822 199.055L7.61821 199.185L7.45821 199.235C7.24812 199.295 7.04119 199.365 6.83821 199.445H6.7382L6.2382 199.645L6.04822 199.725L5.64821 199.905L5.45821 200.005L5.06821 200.215L4.89821 200.305L4.39821 200.625C4.22821 200.745 4.05821 200.865 3.89821 200.995L3.75821 201.105L3.42821 201.395L3.2682 201.545L2.81821 201.995C2.71821 202.115 2.60821 202.235 2.50821 202.365L2.41821 202.485C2.28821 202.655 2.15821 202.825 2.03821 203.005L1.95821 203.135C1.86821 203.275 1.77821 203.425 1.69821 203.575C1.61821 203.725 1.62821 203.715 1.58821 203.775C1.54821 203.835 1.44821 204.045 1.38821 204.195C1.32821 204.345 1.31821 204.345 1.27821 204.415L0.97821 204.985L0.898209 205.195C0.818209 205.425 0.738213 205.665 0.668213 205.915C0.598213 206.165 0.538205 206.485 0.488205 206.795C0.438205 207.105 0.428213 207.445 0.418213 207.795C0.526585 210.86 1.30482 213.864 2.69821 216.595C3.56914 218.483 4.5716 220.308 5.69821 222.055C6.19821 222.815 6.69821 223.585 7.28821 224.365C10.9352 229.297 15.2 233.74 19.9782 237.585C21.4382 238.792 22.9849 239.982 24.6182 241.155C27.4925 243.207 30.477 245.1 33.5582 246.825C44.3082 252.825 57.8982 257.925 74.5582 260.635C77.2249 261.075 79.9982 261.449 82.8782 261.755C89.2456 262.432 95.6449 262.766 102.048 262.755C109.548 262.793 117.038 262.201 124.438 260.985C127.068 260.535 129.598 259.985 132.038 259.405C147.848 255.495 159.648 248.325 168.388 239.005C168.768 238.605 169.138 238.195 169.498 237.785C170.088 237.125 170.668 236.455 171.228 235.785L172.108 234.695C172.978 233.585 173.808 232.465 174.608 231.305C175.048 230.675 175.478 230.035 175.888 229.385C177.673 226.626 179.276 223.753 180.688 220.785C181.048 220.035 181.398 219.285 181.688 218.515C181.908 218.025 182.118 217.515 182.328 217.045C182.768 215.985 183.198 214.925 183.598 213.845C183.885 213.079 184.165 212.299 184.438 211.505C184.688 210.795 184.928 210.085 185.158 209.365L185.788 207.365C186.119 207.414 186.454 207.437 186.788 207.435C187.598 207.437 188.403 207.302 189.168 207.035C193.269 205.684 197.052 203.514 200.288 200.655C203.902 197.409 206.57 193.245 208.008 188.605C209.463 183.751 209.916 178.651 209.338 173.615ZM112.068 26.7154C112.114 26.7178 112.159 26.7035 112.195 26.6751C112.232 26.6467 112.256 26.6061 112.265 26.5609C112.273 26.5158 112.265 26.469 112.242 26.4294C112.219 26.3897 112.182 26.3599 112.138 26.3454C107.628 24.2454 103.028 22.2054 104.028 18.5354C104.508 16.7654 106.028 16.0554 107.958 16.0554C110.926 16.2801 113.811 17.1395 116.418 18.5754C116.448 18.5846 116.479 18.5846 116.508 18.5754C116.547 18.5757 116.584 18.5643 116.616 18.5429C116.648 18.5214 116.672 18.4907 116.687 18.455C116.701 18.4193 116.704 18.3801 116.695 18.3427C116.686 18.3053 116.667 18.2713 116.638 18.2454C113.368 14.8954 109.828 11.3554 112.908 7.83536C113.253 7.48612 113.669 7.21584 114.128 7.04319C114.588 6.87054 115.079 6.79963 115.568 6.83536C121.828 6.83536 134.148 17.2854 131.768 32.4754L131.478 32.4154L131.078 32.3354L130.788 32.2754L130.378 32.1954L129.648 32.0654H129.418L128.758 31.9554H128.628L128.078 31.8754H127.838L127.408 31.8154H126.468L126.058 31.7654H125.138L124.608 31.7154H115.928L114.648 31.7754H114.558L113.388 31.8554H113.258L112.158 31.9454H111.978L110.908 32.0554H110.788L109.718 32.1854H109.638L108.548 32.3254L107.048 32.5454L105.518 32.8154L105.108 32.8954C104.108 33.0754 103.198 33.2754 102.208 33.5054L101.718 33.6254L101.508 33.6754C102.658 27.4954 107.698 26.9854 112.068 26.7154ZM18.9182 181.815C23.0226 172.254 27.9126 163.049 33.5382 154.295C40.1082 144.085 43.9382 140.605 45.2582 139.885C45.3351 139.833 45.4193 139.793 45.5082 139.765C47.1182 139.845 49.2082 141.675 51.0282 144.585C51.0882 144.695 51.1582 144.795 51.2182 144.895C56.5982 153.835 58.6582 169.695 52.7882 180.765C51.6869 182.867 50.3445 184.834 48.7882 186.625C44.986 190.881 40.1704 194.108 34.7882 196.005C33.5682 196.455 32.4382 196.795 31.4582 197.055C23.6782 199.105 17.2782 198.265 15.0382 196.985C14.8482 196.445 14.1882 193.165 18.9182 181.815ZM184.768 181.075C184.1 188.849 182.734 196.546 180.688 204.075C180.122 206.122 179.502 208.122 178.828 210.075C175.884 218.815 171.268 226.898 165.238 233.875C158.581 241.262 150.267 246.965 140.978 250.515C130.138 254.765 117.068 256.925 102.118 256.925C94.9513 256.944 87.7904 256.51 80.6782 255.625C77.8582 255.265 75.0782 254.835 72.3582 254.335C62.2977 252.537 52.5062 249.469 43.2182 245.205C30.5682 239.315 19.7982 231.075 12.8782 222.005C6.5082 213.645 6.08821 208.345 6.31821 207.475C6.84821 205.595 7.95821 204.145 16.7782 204.145H21.5382C28.0882 204.145 33.0682 203.255 37.1382 201.345C46.0522 198.181 53.4771 191.825 57.9782 183.505C65.0782 170.115 62.3882 152.075 56.2582 141.885C54.9642 139.631 53.2499 137.645 51.2082 136.035C51.3482 130.365 51.5782 124.275 51.9982 117.775C53.7882 89.8754 61.4582 68.7754 74.7882 54.9154C81.1626 48.3142 89.0202 43.3295 97.7082 40.3754C101.497 39.081 105.402 38.1534 109.368 37.6054C112.449 37.1706 115.557 36.9501 118.668 36.9454C124.38 36.9082 130.063 37.7515 135.518 39.4454C142.806 41.7803 149.462 45.7517 154.978 51.0554C169.378 64.7254 178.638 88.0554 182.518 120.405C183.148 125.685 183.788 131.455 184.308 137.515C185.488 151.235 186.098 166.495 184.768 181.075ZM203.718 179.145C203.718 180.255 203.598 181.325 203.458 182.365C203.322 183.375 203.132 184.376 202.888 185.365C202.316 187.703 201.367 189.932 200.078 191.965C199.57 192.759 199.009 193.518 198.398 194.235C198.098 194.585 197.778 194.935 197.448 195.235C197.118 195.535 196.768 195.905 196.448 196.235C196.128 196.565 195.768 196.825 195.448 197.115C194.4 197.944 193.286 198.687 192.118 199.335C191.368 199.755 190.598 200.135 189.828 200.475C189.058 200.815 188.268 201.125 187.478 201.395C187.708 200.455 187.918 199.505 188.128 198.555C188.635 196.169 189.078 193.755 189.458 191.315C189.538 190.765 189.628 190.215 189.698 189.665C189.908 188.265 190.088 186.845 190.258 185.425C190.368 184.425 190.468 183.425 190.568 182.425C190.668 181.425 190.758 180.425 190.828 179.425C190.948 177.925 191.048 176.425 191.138 174.925C191.188 173.925 191.238 172.925 191.278 171.925C191.318 170.925 191.348 169.925 191.368 168.925C191.368 168.425 191.368 167.925 191.368 167.415C191.368 166.415 191.368 165.415 191.368 164.415C191.368 162.415 191.368 160.415 191.368 158.415C191.368 157.415 191.368 156.415 191.288 155.415C191.208 154.415 191.218 153.415 191.178 152.415C191.138 151.415 191.098 150.415 191.048 149.415C190.908 146.695 190.728 143.995 190.528 141.325H190.588C190.672 141.387 190.749 141.458 190.818 141.535C191.558 142.405 192.288 143.345 192.998 144.355C193.538 145.115 194.058 145.905 194.578 146.735L195.088 147.575C196.23 149.514 197.259 151.517 198.168 153.575C198.628 154.575 199.068 155.675 199.478 156.755C200.098 158.375 200.658 160.042 201.158 161.755C201.648 163.435 202.088 165.145 202.448 166.865C202.939 169.177 203.306 171.514 203.548 173.865C203.618 174.465 203.668 175.065 203.698 175.655C203.728 176.885 203.748 178.035 203.718 179.145Z"
                        fill="#737373"
                        id="mainIconPathAttribute"
                        stroke="#ffffff"
                      ></path>{" "}
                      <path
                        d="M94.6983 281.986C93.409 281.961 92.1572 281.548 91.1064 280.8C90.0556 280.053 89.2547 279.006 88.8083 277.796L82.8983 261.796C80.0383 261.482 77.265 261.109 74.5783 260.676C77.3083 268.276 80.6783 277.616 81.6283 280.116C81.9483 280.946 81.6283 281.986 80.0883 281.986H70.9783C70.9783 281.986 68.2283 288.056 75.6883 287.836C96.3483 287.216 94.1083 303.756 100.618 300.636C106.878 297.636 94.9583 287.816 95.1383 287.836C118.938 290.836 111.338 281.966 111.338 281.966C111.338 281.966 99.2383 281.986 94.6983 281.986Z"
                        fill="#737373"
                        id="mainIconPathAttribute"
                        stroke="#ffffff"
                      ></path>{" "}
                      <path
                        d="M139.348 273.846C138.765 273.849 138.194 273.676 137.711 273.349C137.227 273.023 136.853 272.558 136.638 272.016C135.548 269.276 133.488 263.446 132.038 259.426C129.598 260.036 127.038 260.556 124.438 261.006C126.008 265.346 128.188 271.356 128.368 271.936C128.798 273.266 128.488 273.766 126.138 273.766H117.308C117.308 273.766 114.758 279.466 124.528 279.466C144.468 279.466 140.318 296.226 147.988 291.936C152.888 289.196 143.788 281.466 143.058 280.546C142.638 280.026 142.978 279.296 144.058 279.456C164.428 282.566 159.428 273.766 159.428 273.766C159.428 273.766 145.328 273.846 139.348 273.846Z"
                        fill="#737373"
                        id="mainIconPathAttribute"
                        stroke="#ffffff"
                      ></path>{" "}
                      <path
                        d="M108.324 103.157C110.722 102.591 112.206 100.189 111.64 97.7917C111.075 95.3944 108.673 93.9097 106.275 94.4755C103.878 95.0413 102.393 97.4434 102.959 99.8407C103.525 102.238 105.927 103.723 108.324 103.157Z"
                        fill="#737373"
                        id="mainIconPathAttribute"
                        stroke="#ffffff"
                      ></path>{" "}
                      <path
                        d="M156.74 102.579C158.836 101.284 159.484 98.5351 158.189 96.4399C156.894 94.3446 154.146 93.6959 152.051 94.991C149.955 96.2861 149.307 99.0345 150.602 101.13C151.897 103.225 154.645 103.874 156.74 102.579Z"
                        fill="#737373"
                        id="mainIconPathAttribute"
                        stroke="#ffffff"
                      ></path>{" "}
                      <path
                        d="M143.888 114.367L132.598 109.687C132.217 109.547 131.814 109.476 131.408 109.477C130.999 109.475 130.593 109.547 130.208 109.687L118.918 114.367C118.56 114.476 118.242 114.687 118.002 114.974C117.763 115.262 117.612 115.613 117.57 115.985C117.527 116.357 117.595 116.733 117.763 117.068C117.932 117.402 118.194 117.68 118.518 117.867L129.978 125.297C130.391 125.592 130.891 125.74 131.398 125.717C131.902 125.739 132.399 125.591 132.808 125.297L144.288 117.867C144.613 117.68 144.875 117.402 145.044 117.068C145.212 116.733 145.279 116.357 145.237 115.985C145.194 115.613 145.044 115.262 144.804 114.974C144.565 114.687 144.246 114.476 143.888 114.367Z"
                        id="mainIconPathAttribute"
                        stroke="#454545"
                        style={{ fill: "#454545" }}
                      ></path>{" "}
                    </svg>
                  </a>
                  <a
                    href="https://www.instagram.com/ondc_official/"
                    className="fa fa-instagram t"
                    target="_blank"
                  >
                    <InstagramIcon style={{ fontSize: "2.4rem" }} />
                  </a>
                </div>
              </div>
              <div></div>
            </div>
          </footer>
        </body>
      ) : (
        <PageLoading />
      )}
    </>
  );
}
export default ONDCLandingPage;
